import React from "react";

// Building blocks shared by the refreshed pages (home, career stats, charts,
// leaderboards, race results). Styles live in styles/_modern.scss.

export const LoadingOverlay = () => (
        <div className="hp-loading">
                <div className="spinner"></div>
        </div>
);

export const PanelHeader = ({ title, action, children }) => (
        <div className="hp-panel__head">
                <h2 className="hp-panel__title">{title}</h2>
                <div className="hp-panel__tools">
                        {children}
                        {action}
                </div>
        </div>
);

export const SegmentedControl = ({ options, value, onChange, label, variant }) => (
        <div className={`hp-seg${variant ? ` hp-seg--${variant}` : ""}`} role="group" aria-label={label}>
                {options.map((opt) => (
                        <button
                                key={opt.value}
                                type="button"
                                className={`hp-seg__btn${value === opt.value ? " is-active" : ""}`}
                                aria-pressed={value === opt.value}
                                title={opt.title}
                                aria-label={opt.title}
                                onClick={() => onChange(opt.value)}
                        >
                                {opt.content}
                        </button>
                ))}
        </div>
);

// Icon buttons on desktop, a native select on narrow screens.
export const CategoryFilter = ({ options, value, onChange, label }) =>
        window.innerWidth > 800 ? (
                <SegmentedControl options={options} value={value} onChange={onChange} label={label} />
        ) : (
                <select className="hp-select" value={value} onChange={(e) => onChange(e.target.value)} aria-label={label}>
                        {options.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                        {opt.title}
                                </option>
                        ))}
                </select>
        );

// Multi-select toggle group: any number of options can be on at once.
export const ToggleGroup = ({ options, selected, onToggle, label }) => (
        <div className="hp-seg" role="group" aria-label={label}>
                {options.map((opt) => {
                        const active = selected.includes(opt.value);
                        return (
                                <button
                                        key={opt.value}
                                        type="button"
                                        className={`hp-seg__btn${active ? " is-active" : ""}`}
                                        aria-pressed={active}
                                        title={opt.title}
                                        aria-label={opt.title}
                                        style={opt.color ? { color: active ? undefined : opt.color } : undefined}
                                        onClick={() => onToggle(opt.value)}
                                >
                                        {opt.content}
                                </button>
                        );
                })}
        </div>
);

// Plain page title for data pages, with an optional line of context underneath.
export const PageHeader = ({ title, lede, children }) => (
        <header className="pg-head">
                <div>
                        <h1 className="pg-head__title">{title}</h1>
                        {lede && <p className="pg-head__lede">{lede}</p>}
                </div>
                {children && <div className="pg-head__tools">{children}</div>}
        </header>
);

// Full-panel loading state used while a page waits for its first data.
export const LoadingPanel = ({ label = "Loading data…" }) => (
        <section className="hp-panel pg-loading" aria-busy="true">
                <div className="spinner"></div>
                <p className="hp-panel__note">{label}</p>
        </section>
);
